// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateIndonesianPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!(phoneNumberValue && phoneNumberValue.trim())) {
    return { id: 'empty' };
  }

  if (!parseInt(phoneNumberValue)) {
    return { id: 'only-numbers' };
  }

  if (phoneNumberValue.length < 8) {
    return { id: 'min-length' };
  }
}
